var map = {
	"./ed-sheeran.png": "1f15",
	"./emily-blunt.png": "add7",
	"./king-george.png": "aac4",
	"./marilyn-monroe.png": "8e80",
	"./nye-bevan.png": "cf9e",
	"./stormzy.png": "1308",
	"./winston-churchill.png": "0b6a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ad0";